module.exports = __webpack_public_path__ + "img/md.1e13f316.svg";